export const PRIMARY_CULTURES_MAX_SELECTED = 6 as const;
export const OTHER_CULTURES_MAX_SELECTED = 50 as const;
